import { IPetColorItemResponse, IPetColorResponse } from "./pet-colors.interface";
import { useEffect, useState } from "react";

import { IOptionGeneric } from "../../shared/interface";
import { PET_COLORS } from "./pet-colors.query";
import { useLazyQuery } from "@apollo/client";

export const usePetColors = () => {
  const [colors, setColors] = useState<IOptionGeneric[]>([]);
  const [getPetColors, { loading, error, data }] = useLazyQuery<{ getPetColors: IPetColorResponse }>(PET_COLORS);

  const searchPetColors = (input: string) => {
    if (!input) {
      setColors([]);
    } else {
      getPetColors({
        variables: { data: {
          active: true,
          searchCriteria: input,
        } },
      });
    }
  };

  useEffect(() => {
    if (data) {
      setColors(data ? colorResponseMap(data.getPetColors.colors) : []);
    }
  }, [data]);

  return {
    colors,
    loading,
    error,
    searchPetColors,
  };
};

const colorResponseMap = (colors: IPetColorItemResponse[]): IOptionGeneric[] => {
  return colors.map((color: IPetColorItemResponse) => ({
    value: color.id,
    label: color.name,
  }));
};
